console.log("Ranking Engine Loaded");

const PRODUCT_SCORE = {

    "8mp":40,

    "5mp":30,

    "4mp":25,

    "3mp":20,

    "2mp":15,

    "4g":30,

    "ptz":25,

    "dual lens":20,

    "three-lens":25,

    "four-lens":30,

    "ai":25,

    "human detection":20,

    "wifi":15,

    "night vision":15,

    "two way":10,

    "two-way":10,

    "motion detection":10,

    "sd card":5,

    "cloud":5,

    "360":15,

    "pan":10,

    "tilt":10

};

function calculateProductScore(product){

    const text=(

        product.title+" "+

        product.product_type+" "+

        (product.tags || []).join(" ")

    ).toLowerCase();

    let score=0;

    for(const keyword in PRODUCT_SCORE){

        if(text.includes(keyword)){

            score += PRODUCT_SCORE[keyword];

        }

    }

    return score;

}

function getBestProduct(products){

    let best=null;

    let highestScore=-1;

    products.forEach(product=>{

        const score=calculateProductScore(product);

        console.log(product.title);

        console.log("Score:",score);

        if(score>highestScore){

            highestScore=score;

            best=product;

        }

    });

    return best;

}